// SiteLayout.tsx
import React from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../../../components/layout-components/Header";
import { useMediaQuery, useTheme } from "@mui/material";
import MobileHeader from "../../../components/layout-components/MobileHeader";
import DashboardHome from "./home";
import DashboardAbout from "./about";
import DashboardMembers from "./members";
import DashboardMemberDetail from "./members/components/MemberDetail";
import DashboardContact from "./contact";
import DashboardEvents from "./events";
import DashboardEventDetail from "./events/components/EventDetail";
import DashboardMembership from "./membership";


function SiteLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      {!isMobile ? <Header /> : <MobileHeader />}
      <Routes>
        <Route path="/auth" element={<DashboardHome />} />
        <Route path="/auth/hakkimizda" element={<DashboardAbout />} />
        <Route path="/auth/uyeler" element={<DashboardMembers />} />
        <Route path="/auth/uyeler/:id/:name" element={<DashboardMemberDetail />} />
        <Route path="/auth/iletisim" element={<DashboardContact />} />
        <Route path="/auth/etkinlikler" element={<DashboardEvents />} />
        <Route path="/auth/etkinlikler/:id/:title" element={<DashboardEventDetail />} />
        <Route path="/auth/uyelik" element={<DashboardMembership />} />
      </Routes>
    </>
  );
}

export default SiteLayout;
